// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__28yIp","topBottomGutter":"Layout_topBottomGutter__1Pzum"};